var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('WidgetTile',{attrs:{"item":_vm.data,"title":_vm.conf.title}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }